import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BatchService } from '@lead-hunter/data-access';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'lead-warning-remove',
  templateUrl: './warning-remove.component.html',
  styleUrls: ['./warning-remove.component.scss']
})
export class WarningRemoveComponent {

  public id;

  constructor(private batchService: BatchService, public router: Router,
    public spinner: NgxSpinnerService, public dialog: MatDialog) { }

  removeFile() {
    this.spinner.show();
    this.batchService.delete(this.id).subscribe(
      () => {
        this.dialog.closeAll();
      },
      () => {
        this.dialog.closeAll();
      }
    );
  }
}
